export default "__VITE_ASSET__BVKekC6l__"